import { Spin } from 'antd';
import React from 'react';
export const LoadingFooter = () => {
    return (React.createElement("div", { className: "flex justify-center items-center p-6" },
        React.createElement(Spin, { size: "large" })));
};
